import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { GbpersonService, PersonGbMasterDetailEntryMeta, PersonGbMasterId, PersonGbVersionId } from 'app/core/gb-api';
import { HistoryMode } from 'app/core/services/HistoryMode';
import { AppConfigService } from 'app/core/services/app-config.service';
import { TimepointService } from 'app/core/services/timepoint.service';
import { catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { CapAlertService } from '../../../core/extension/exceptions/cap-alert.service';
import { CapAlertLevel } from '../../../core/extension/exceptions/cap-alert-level.enum';

@Injectable()
export class PersonGbResolver {
  historyMode: HistoryMode.HistoryMode;
  personGbMasterId: PersonGbMasterId;
  personGbVersionId: PersonGbVersionId;

  readonly PERSON_GB_ID = 'id';
  readonly PERSON_GB_VERSION_ID = 'versionId';

  constructor(
    private appConfigService: AppConfigService,
    private persongbService: GbpersonService,
    private zeitpunktService: TimepointService,
    private translate: TranslateService,
    private capAlertService: CapAlertService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PersonGbMasterDetailEntryMeta> {
    this.historyMode = this.appConfigService.einstellungHistorischeDaten;
    this.personGbMasterId = <PersonGbMasterId>{ id: route.queryParamMap.get(this.PERSON_GB_ID) };
    this.personGbVersionId = <PersonGbVersionId>{ id: route.queryParamMap.get(this.PERSON_GB_VERSION_ID) };
    return this.loadPersonGb().pipe(catchError((err) => this.handleError(err)));
  }

  handleError(err): Observable<any> {
    if (err.status === 502) {
      this.capAlertService.warning(this.translate.instant('zpvService.nichtVerfuegbar'), CapAlertLevel.CONTENT_HEADER);
      return EMPTY;
    }
    return EMPTY;
  }

  private loadPersonGb() {
    if (this.personGbMasterId && this.personGbMasterId.id) {
      return this.persongbService.loadPersonGbById(
        this.historyMode, //
        this.personGbMasterId.id, //
        this.personGbVersionId.id, //
        this.zeitpunktService.timepointCtx.timepointIso, //
        this.zeitpunktService.timepointCtx.timepointId //
      );
    }
  }
}
